module.exports = __webpack_public_path__ + "static/media/er.fa14fa27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/er.png
// module id = 1841
// module chunks = 0